const AUTH_TOKEN_PREFIX = "@@auth0spajs@@::";
const ID_TOKEN_SUFFIX = "::@@user@@";
const ACCESS_TOKEN_SUFFIX =
  "::https://tunnus-dev.almamedia.net::openid profile email";

// @ts-ignore
const CONSUMER_CLIENT_ID = import.meta.env.VITE_ALMA_SSO_CLIENT_ID;
// @ts-ignore
const DEALER_CLIENT_ID = import.meta.env.VITE_ALMA_SSO_CLIENT_ID_DEALER;

const localStorageHasAnyAuthToken = (): boolean => {
  const hasConsumerIdToken =
    localStorage.getItem(
      `${AUTH_TOKEN_PREFIX}${CONSUMER_CLIENT_ID}${ID_TOKEN_SUFFIX}`
    ) !== null;
  const hasConsumerAccessToken =
    localStorage.getItem(
      `${AUTH_TOKEN_PREFIX}${CONSUMER_CLIENT_ID}${ACCESS_TOKEN_SUFFIX}`
    ) !== null;
  const hasDealerIdToken =
    localStorage.getItem(
      `${AUTH_TOKEN_PREFIX}${DEALER_CLIENT_ID}${ID_TOKEN_SUFFIX}`
    ) !== null;
  const hasDealerAccessToken =
    localStorage.getItem(
      `${AUTH_TOKEN_PREFIX}${DEALER_CLIENT_ID}${ACCESS_TOKEN_SUFFIX}`
    ) !== null;
  const localStorageHasAnyAuthToken =
    hasConsumerIdToken ||
    hasConsumerAccessToken ||
    hasDealerIdToken ||
    hasDealerAccessToken;

  return localStorageHasAnyAuthToken;
};

const localStorageHasPreviousSessionFlag = (): boolean => {
  return localStorage.getItem("PREVIOUS_SESSION") !== null;
};

const clearAuthTokens = (): void => {
  localStorage.removeItem(
    `${AUTH_TOKEN_PREFIX}${CONSUMER_CLIENT_ID}${ID_TOKEN_SUFFIX}`
  );
  localStorage.removeItem(
    `${AUTH_TOKEN_PREFIX}${CONSUMER_CLIENT_ID}${ACCESS_TOKEN_SUFFIX}`
  );
  localStorage.removeItem(
    `${AUTH_TOKEN_PREFIX}${DEALER_CLIENT_ID}${ID_TOKEN_SUFFIX}`
  );
  localStorage.removeItem(
    `${AUTH_TOKEN_PREFIX}${DEALER_CLIENT_ID}${ACCESS_TOKEN_SUFFIX}`
  );
};

export interface BusinessSSOConfig {
  name: string;
  alias: string;
  audience: string;
  clientID: string;
  domain: string;
  realm: string;
  scope: string;
  redirectUri: string;
}

const BUSINESS_SSO_CONFIGS: Record<string, BusinessSSOConfig> = {
  "atad-rintajoupinautoliike-waad": {
    name: "Rinta-Joupin Autoliike",
    alias: "rja",
    // @ts-ignore
    audience: import.meta.env.VITE_ALMA_SSO_AUDIENCE,
    // @ts-ignore
    clientID: import.meta.env.VITE_ALMA_SSO_CLIENT_ID_DEALER,
    // @ts-ignore
    domain: import.meta.env.VITE_ALMA_SSO_DOMAIN,
    realm: "atad-rintajoupinautoliike-waad",
    scope: "openid profile email",
    // @ts-ignore
    redirectUri: import.meta.env.VITE_ALMA_SSO_REDIRECT_URL
  }
} as const;

const getBusinessConfigByAlias = (
  alias: string
): BusinessSSOConfig | undefined =>
  Object.values(BUSINESS_SSO_CONFIGS).find((config) => config.alias === alias);

const getBusinessConfigByRealm = (
  realm: string
): BusinessSSOConfig | undefined => BUSINESS_SSO_CONFIGS[realm];

const isValidBusinessAlias = (alias: string): boolean =>
  Object.values(BUSINESS_SSO_CONFIGS).some((config) => config.alias === alias);

export {
  localStorageHasAnyAuthToken,
  localStorageHasPreviousSessionFlag,
  clearAuthTokens,
  BUSINESS_SSO_CONFIGS,
  getBusinessConfigByAlias,
  getBusinessConfigByRealm,
  isValidBusinessAlias
};
